<div class="package-list-wrapper">
  <div class="message info" *ngIf="isLoading">Loading package list...</div>
  <div class="message error" *ngIf="error">{{ error }}</div>

  <app-entity-list
    *ngIf="!error"
    [loading]="isLoading"
    [list]="packages"
    [tableHeaderAndValueKeySets]="tableHeaderAndValueKeySets"
    [emptyMessage]="'No packages found.'"
    [menuActions]="packageMenuActions"
    (cardClick)="onCardClickFromList($event)"
    (editClick)="onEditClickFromList($event)"
    (deleteClick)="onDeleteClickFromList($event)"
    (menuAction)="onMenuAction($event)"
  ></app-entity-list>

  <app-add-edit-package
    *ngIf="isEditOpen && selectedPackage"
    [mode]="'edit'"
    [initialPackage]="selectedPackage"
    (close)="closeEditModal()"
    (save)="onEditSave($event)"
  ></app-add-edit-package>

  <app-confirm-action-modal
    [visible]="!!pendingDeletePackage"
    [title]="'package.deleteTitle' | t:'Delete Package'"
    [message]="'package.deleteMessage' | t:'Delete this package?'"
    [confirmLabel]="'action.delete' | t:'Delete'"
    [isLoading]="isDeleting"
    [danger]="true"
    (cancel)="closeDeleteModal()"
    (confirm)="confirmDeletePackage()"
  ></app-confirm-action-modal>

  <div class="modal-overlay" *ngIf="isHistoryOpen && selectedPackage" (click)="closeHistoryModal()">
    <div class="details-modal history-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeHistoryModal()">&times;</button>
      <h3>Package History</h3>
      <div class="history-subtitle">
        {{ selectedPackage.packageName || 'N/A' }}
      </div>

      <div class="history-list" *ngIf="selectedPackageHistory.length > 0; else emptyHistory">
        <div class="history-header">
          <span>Updated On</span>
          <span>Action</span>
          <span>Package</span>
          <span>Summary</span>
          <span>Monthly</span>
          <span>Yearly</span>
        </div>
        <div class="history-card" *ngFor="let history of selectedPackageHistory" (click)="openHistoryDetails(history)">
          <span>{{ formatDateTime(history.createdOn) }}</span>
          <span>{{ history.actionStatus || 'N/A' }}</span>
          <span>{{ history.packageName || 'N/A' }}</span>
          <span class="history-summary">{{ historySummary(history) }}</span>
          <span>{{ formatPrice(history.priceMonthly) }}</span>
          <span>{{ formatPrice(history.priceYearly) }}</span>
        </div>
      </div>

      <ng-template #emptyHistory>
        <div class="message info">No history found.</div>
      </ng-template>

      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeHistoryModal()">Close</button>
      </div>
    </div>
  </div>

  <div class="modal-overlay" *ngIf="isHistoryDetailsOpen && selectedHistoryItem" (click)="closeHistoryDetailsModal()">
    <div class="details-modal" (click)="$event.stopPropagation()">
      <button class="close-icon" type="button" aria-label="Close" (click)="closeHistoryDetailsModal()">&times;</button>
      <h3>Package History Details</h3>
      <div class="details-grid">
        <div class="details-item">
          <span class="label">History ID</span>
          <span class="value">{{ selectedHistoryItem.id || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Package ID</span>
          <span class="value">{{ selectedHistoryItem.packageId || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Updated On</span>
          <span class="value">{{ formatDateTime(selectedHistoryItem.createdOn) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Action</span>
          <span class="value">{{ selectedHistoryItem.actionStatus || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Package</span>
          <span class="value">{{ selectedHistoryItem.packageName || 'N/A' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Status</span>
          <span class="value">{{ selectedHistoryItem.status === 1 ? 'Active' : 'Inactive' }}</span>
        </div>
        <div class="details-item">
          <span class="label">Flat Limit</span>
          <span class="value">{{ selectedHistoryItem.totalFlat || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">Renter Limit</span>
          <span class="value">{{ selectedHistoryItem.totalRenter || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">Subuser Limit</span>
          <span class="value">{{ selectedHistoryItem.maxActiveEmployee || 0 }}</span>
        </div>
        <div class="details-item">
          <span class="label">File Storage</span>
          <span class="value">{{ formatStorage(selectedHistoryItem.maxFileMemory) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Monthly</span>
          <span class="value">{{ formatPrice(selectedHistoryItem.priceMonthly) }}</span>
        </div>
        <div class="details-item">
          <span class="label">Yearly</span>
          <span class="value">{{ formatPrice(selectedHistoryItem.priceYearly) }}</span>
        </div>
      </div>
      <div class="details-actions">
        <button type="button" class="panel-item" (click)="closeHistoryDetailsModal()">Close</button>
      </div>
    </div>
  </div>
</div>
